import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import style from '../css/matchDayLeagueUpdate.css';
import {BOTH_TEAMS_SCORE, UNDER_OVER_25, WIN_DRAW_WIN, UNDER_OVER_35} from '../modules/matchday/constants/marketTypes';
import {getMarketsByCode} from '../modules/matchday/helpers/marketHelpers';
import OddsButton from "../modules/matchday/components/oddsButton";
import {getText} from '../../../helpers/localization';
import {OPERATOR} from "../../../constants/operator";

const mapStateToProps = (state, ownProps) => {
    return {
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
    };
};

class MatchDayLeagueUpdate extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.winRef = React.createRef();
        this.drawRef = React.createRef();
        this.looseRef = React.createRef();
        this.bttsNoRef = React.createRef();
        this.bttsYesRef = React.createRef();
        this.underRef = React.createRef();
        this.overRef = React.createRef();
        this.underThreeRef = React.createRef();
        this.overThreeRef = React.createRef();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
            });
        }
    }

    _triggerOddsClick(oddsReference) {
        oddsReference.current.click();
    }

    render() {
        if (this.state.events[this.state.selectedEventIndex] === undefined || this.state.events[this.state.selectedEventIndex].length === undefined)
            return null;

        let position = parseInt(this.props.leagueUpdate.position) + 1;
        let teamName = this.props.leagueUpdate.teamName;
        let teamShortName = getText('Matchday_' + this.props.leagueUpdate.teamName, this.props.store);
        let matchesPlayed = this.props.leagueUpdate.matchesPlayed;
        let matchesWon = this.props.leagueUpdate.matchesWon;
        let matchesDrawn = this.props.leagueUpdate.matchesDrawn;
        let matchesLost = this.props.leagueUpdate.matchesLost;
        let goalsScored = this.props.leagueUpdate.goalsScored;
        let goalsAgainst = this.props.leagueUpdate.goalsAgainst;
        let points = this.props.leagueUpdate.points;
        let trend = this.props.leagueUpdate.trend;
        let rowId = this.props.rowId;
        let toggled = (this.props.activeRow == rowId && this.props.activeRowToggled) ? style.toggleIn : style.toggleOut;
        let arrow = (this.props.activeRow == rowId && this.props.activeRowToggled) ? style.leagueUpdateDown : style.leagueUpdateRight;

        //finding very next event of a team
        let event = this.state.events[this.state.selectedEventIndex].slice().find((event) => event.title.toLowerCase().includes(teamName.toLowerCase()));

        if (event === undefined)
            return null;

        let marketList = event.markets;
        let windDrawWinMarkets = getMarketsByCode(WIN_DRAW_WIN, marketList);
        let bothTeamToScoreMarkets = getMarketsByCode(BOTH_TEAMS_SCORE, marketList);
        let underOver25Markets = getMarketsByCode(UNDER_OVER_25, marketList);
        let underOver35Markets = getMarketsByCode(UNDER_OVER_35, marketList);
        let lastRowToggledStyle = (this.props.rowId == this.props.activeRow && this.props.activeRowToggled) ?
            style.lastLeagueUpdateRowToggled : '';
        let highLightRowStyle = (event.teamOne == this.props.activeRowTeamName || event.teamTwo == this.props.activeRowTeamName) ?
            style.highLightRow : '';

        let availableContents = [{
            name: WIN_DRAW_WIN.name,
            content: (<div className={style.leagueMarketCellLarge}>
                <div className={`${style.marketRow}`}>
                    {getText('WIN_DRAW_WIN', this.props.store)}
                </div>
                <div className={`${style.marketRow} ${style.oddsContainer}`}>
                    <div className={style.marketOdds}>
                        <div className={style.marketOddsHeader}
                             onClick={() => this._triggerOddsClick(this.winRef)}>1
                        </div>
                        <OddsButton active={true} market={windDrawWinMarkets[0]} event={event}
                                    store={this.props.store}
                                    reference={this.winRef}
                                    circleSize={'small'} customStyle={style.oddsBtn}/>
                    </div>
                    <div className={`${style.marketOddsDraw} ${style.marketOdds}`}>
                        <div className={style.marketOddsHeader}
                             onClick={() => this._triggerOddsClick(this.drawRef)}>X
                        </div>
                        <OddsButton active={true} market={windDrawWinMarkets[1]} event={event}
                                    store={this.props.store}
                                    reference={this.drawRef}
                                    circleSize={'small'} customStyle={style.oddsBtn}></OddsButton>
                    </div>
                    <div className={style.marketOdds}>
                        <div className={style.marketOddsHeader}
                             onClick={() => this._triggerOddsClick(this.looseRef)}>2
                        </div>
                        <OddsButton active={true} market={windDrawWinMarkets[2]} event={event}
                                    store={this.props.store}
                                    reference={this.looseRef}
                                    circleSize={'small'} customStyle={style.oddsBtn}></OddsButton>
                    </div>
                </div>
            </div>)
        },{
            name: BOTH_TEAMS_SCORE.name,
            content: (<div className={style.leagueMarketCellMedium}>
                <div className={`${style.marketRow}`}>
                    {getText('BOTH_TEAMS_SCORE_INITIALS', this.props.store)}
                </div>
                <div className={`${style.marketRow} ${style.oddsContainer}`}>
                    <div className={`${style.marketOddsBttsYes} ${style.marketOdds}`}>
                        <div className={style.marketOddsHeader}
                             onClick={() => this._triggerOddsClick(this.bttsYesRef)}>{getText('YES', this.props.store)}</div>
                        <OddsButton active={true} market={bothTeamToScoreMarkets[0]} event={event}
                                    store={this.props.store}
                                    reference={this.bttsYesRef}
                                    circleSize={'small'} customStyle={style.oddsBtn}></OddsButton>
                    </div>
                    <div className={style.marketOdds}>
                        <div className={style.marketOddsHeader}
                             onClick={() => this._triggerOddsClick(this.bttsNoRef)}>{getText('NO', this.props.store)}</div>
                        <OddsButton active={true} market={bothTeamToScoreMarkets[1]} event={event}
                                    store={this.props.store}
                                    reference={this.bttsNoRef}
                                    circleSize={'small'} customStyle={style.oddsBtn}></OddsButton>
                    </div>
                </div>
            </div>)
        },{
            name: UNDER_OVER_35.name,
            content: (<div className={style.leagueMarketCellMedium}>
                <div className={`${style.marketRow}`}>
                    {getText('UNDER_OVER_35_INITIALS', this.props.store)}
                </div>
                <div className={`${style.marketRow} ${style.oddsContainer}`}>
                    <div className={`${style.marketOddsUnder} ${style.marketOdds}`}>
                        <div className={style.marketOddsHeader} onClick={() => this._triggerOddsClick(this.underThreeRef)}>{getText('OVER_SHORT',this.props.store)}</div>
                        <OddsButton active={true} market={underOver35Markets[1]} event={event} store={this.props.store}
                                    reference={this.underThreeRef}
                                    circleSize={'small'} customStyle={style.oddsBtn}></OddsButton>
                    </div>
                    <div className={style.marketOdds}>
                        <div className={style.marketOddsHeader} onClick={() => this._triggerOddsClick(this.overThreeRef)}>{getText('UNDER_SHORT',this.props.store)}</div>
                        <OddsButton active={true} market={underOver35Markets[0]} event={event} store={this.props.store}
                                    reference={this.overThreeRef}
                                    circleSize={'small'} customStyle={style.oddsBtn}></OddsButton>
                    </div>
                </div>
            </div>)
        },{
            name: UNDER_OVER_25.name,
            content: (<div className={style.leagueMarketCellMedium}>
                <div
                    className={`${style.marketRow}`}>{getText('UNDER_OVER_25_INITIALS', this.props.store)}</div>
                <div className={`${style.marketRow} ${style.oddsContainer}`}>
                    <div className={`${style.marketOddsUnder} ${style.marketOdds}`}>
                        <div className={style.marketOddsHeader}
                             onClick={() => this._triggerOddsClick(this.underRef)}>{getText('OVER_SHORT', this.props.store)}</div>
                        <OddsButton active={true} market={underOver25Markets[1]} event={event}
                                    store={this.props.store}
                                    reference={this.underRef}
                                    circleSize={'small'} customStyle={style.oddsBtn}></OddsButton>
                    </div>
                    <div className={style.marketOdds}>
                        <div className={style.marketOddsHeader}
                             onClick={() => this._triggerOddsClick(this.overRef)}>{getText('UNDER_SHORT', this.props.store)}</div>
                        <OddsButton active={true} market={underOver25Markets[0]} event={event}
                                    store={this.props.store}
                                    reference={this.overRef}
                                    circleSize={'small'} customStyle={style.oddsBtn}></OddsButton>
                    </div>
                </div>
            </div>)
        }];

        let showContents = [];
        let marketsOrderConfig = OPERATOR.matchdayMarketsOrder ? JSON.parse(OPERATOR.matchdayMarketsOrder) : [];

        marketsOrderConfig.forEach((market) => {
            showContents.push(availableContents.find(mdMarket => mdMarket.name === market).content);
        });

        return (
            <Fragment key={rowId}>
                <div className={`${style.leagueUpdateRow} ${lastRowToggledStyle} ${highLightRowStyle}`}
                     onClick={this.props.trigger}>
                    <div className={`${style.cellSmall} ${style.alignRight}`}>
                        <div className={arrow}/>
                    </div>
                    <div className={style.cellPos}><p>{position}</p></div>
                    <div className={`${style.cellMedium} ${style.teamName}`}><p>{teamShortName}</p></div>
                    <div className={style.cellMedium}><p>{matchesPlayed}</p></div>
                    <div className={style.cellMedium}><p>{matchesWon}</p></div>
                    <div className={style.cellMedium}><p>{matchesDrawn}</p></div>
                    <div className={style.cellMedium}><p>{matchesLost}</p></div>
                    <div className={style.cellMedium}><p>{goalsScored}</p></div>
                    <div className={style.cellMedium}><p>{goalsAgainst}</p></div>
                    <div className={`${style.cellMedium} ${style.pointsHeader}`}><p>{points}</p></div>
                    <div className={`${style.cellLarge} ${style.trendHeader}`}>
            <span className={style.trendGroup}>
              {
                  trend.split("").slice(0, 5).map((item, index) => {
                      switch (item) {
                          case 'V':
                              return <Fragment key={index}>
                                  <div className={`${style.win} ${style.trendIcon}`}>
                                      <div className={style.iconOverlay}></div>
                                  </div>
                              </Fragment>
                              break;
                          case 'N':
                              return <Fragment key={index}>
                                  <div className={`${style.draw} ${style.trendIcon}`}>
                                      <div className={style.iconOverlay}></div>
                                  </div>
                              </Fragment>

                              break;
                          case 'P':
                              return <Fragment key={index}>
                                  <div className={`${style.loose} ${style.trendIcon}`}>
                                      <div className={style.iconOverlay}></div>
                                  </div>
                              </Fragment>
                              break;
                          default:
                              return '';
                              break;
                      }
                  })
              }
            </span>
                    </div>
                </div>
                <div className={`${style.leagueUpdateMarketRow} ${toggled}`}>
                    <div className={`${style.leagueMarketCell} ${style.matchName}`}>
                        <span>{getText('Matchday_' + event.teamOne, this.props.store)} - {getText('Matchday_' + event.teamTwo, this.props.store)}</span>
                    </div>
                        {showContents}
                    </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps)(MatchDayLeagueUpdate);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/matchDayLeagueUpdate.js